var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#4D7EFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9401 7.05697C12.1849 6.30176 11.1484 5.83301 9.9974 5.83301C7.69531 5.83301 5.83594 7.69759 5.83594 9.99967C5.83594 12.3018 7.69531 14.1663 9.9974 14.1663C11.9401 14.1663 13.5599 12.8382 14.0234 11.0413H12.9401C12.513 12.2549 11.3568 13.1247 9.9974 13.1247C8.27344 13.1247 6.8724 11.7236 6.8724 9.99967C6.8724 8.27572 8.27344 6.87467 9.9974 6.87467C10.862 6.87467 11.6328 7.23405 12.1953 7.80176L10.5182 9.47884H14.1641V5.83301L12.9401 7.05697Z",
    fill: "#4D7EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailReload);
export default __webpack_public_path__ + "static/media/email-reload.6e9ff7f3812dc69d5fdef979bb84460e.svg";
export { ForwardRef as ReactComponent };